import { lang } from '@umu/ukit-lang';
import { defaultListData, templateTypeTabList } from '../../dataFlow/multiCapabilityTemplate';
import {
    IMultiCapabilityTemplateInfo,
    ISelectTemplateInfo,
    ITemplateQuestionConfig,
    ITemplateListInfo,
    ITemplateParams,
    OPERATE_TYPE,
    TemplateType,
    ISubmitData,
} from '../../interface/multiCapabilityTemplate';
import { getTemplateListByType, delTemplateById, getTemplateQuestionListByType } from '../../server/template';
import { Modal } from '@umu/umu-design';
import { isMock } from '../../dataFlow';
import { textTransformToCapital } from '@umu/umu-util';
const { confirm } = Modal;
const operateBtnList = [
    {
        key: OPERATE_TYPE.VIEW,
        label: lang('查看'),
        showList: [TemplateType.ENTERPRISE, TemplateType.UMU, TemplateType.MY],
    },
    {
        key: OPERATE_TYPE.EDIT,
        label: textTransformToCapital(lang('编辑')),
        showList: [TemplateType.UMU, TemplateType.MY],
    },
    {
        key: OPERATE_TYPE.DELETE,
        label: lang('删除'),
        showList: [TemplateType.MY],
    },
];

const getTemplateAllListInfo = (): [TemplateType[], Promise<ITemplateListInfo>[]] => {
    const list = templateTypeTabList.map((item) => item.value);
    return [
        list,
        list.map((item) => {
            return getTemplateListByType({
                parent_type: item,
                page: 1,
                size: 10,
            });
        }),
    ];
};
const onUpdateTemplateList = (params: ITemplateParams, callback: (data: ITemplateListInfo) => void) => {
    getTemplateListByType(params).then(
        (res) => {
            if (res.list.length === 0 && res.page_info.total_page_num > 1) {
                onUpdateTemplateList(
                    {
                        ...params,
                        page: (params?.page || 0) + 1,
                    },
                    callback,
                );
                return;
            }
            callback(res);
        },
        () => {
            callback(defaultListData);
        },
    );
};
const getTemplateTypeCheck = (listData: Record<string, ITemplateListInfo>, templateType: TemplateType) => {
    if (isMock) {
        // 记得删除
        return TemplateType.MY;
    }
    if (listData[templateType]?.list?.length > 0) {
        return templateType;
    }
    const list = templateTypeTabList
        .filter((item) => item.value !== templateType && listData[templateType]?.list?.length > 0)
        .sort();

    return list?.[0]?.value || templateType;
};
interface IOperateOption {
    callback: (isSuccess: boolean) => void;
}
const onDeleteTemplate = (templateType: TemplateType, record: IMultiCapabilityTemplateInfo, option: IOperateOption) => {
    const { callback } = option;
    const params = {
        parent_type: templateType,
        id: record.id,
    };
    // 目前只有我的模版可以删除
    if (templateType === TemplateType.MY) {
        confirm({
            centered: true,
            title: lang('确认删除'),
            content: lang('请确认是否删除此模板？'),
            okText: lang('删除'),
            cancelText: lang('取消'),
            okType: 'primary',
            onOk() {
                delTemplateById(params).then(callback, () => callback(false));
            },
        });
    }
};
const getTemplateQuestionList = (data: ISelectTemplateInfo, config: ITemplateQuestionConfig): Promise<ISubmitData> => {
    const { templateType, info } = data;
    const { mapInfo } = config;
    const indexKey = `${templateType}_${info.id}`;
    const dataInfo = mapInfo.current?.[indexKey];
    const result = {
        parent_type: templateType,
        list: dataInfo?.list || [],
        templateInfo: dataInfo || info,
    };
    if (!info.id || dataInfo) {
        return Promise.resolve(result);
    }
    const params: ITemplateParams = {
        parent_type: templateType,
        id: info.id,
        get_base: 0,
    };
    if ([TemplateType.ENTERPRISE].includes(templateType)) {
        params.evaluation_criteria_id = info?.evaluation_criteria_id || '';
    }
    return new Promise((resolve) => {
        getTemplateQuestionListByType(params).then((res) => {
            mapInfo.current[indexKey] = res;
            resolve({
                parent_type: templateType,
                templateInfo: res,
            });
        });
    });
};
export {
    operateBtnList,
    getTemplateQuestionList,
    onDeleteTemplate,
    getTemplateAllListInfo,
    onUpdateTemplateList,
    getTemplateTypeCheck,
};
